import { getCurrentCategoryName } from 'facetsHelper';

function updateWorkforceSpecificMeta(intl, searchParams) {
  let metaTitle = intl.formatMessage({ id: 'Workforce.Title' }, { sitename: process.env.REACT_APP_SITENAME });
  let metaDescription = intl.messages['Workforce.MetaDescription'] ? intl.messages['Workforce.MetaDescription'] : null;
  let titleTop = intl.formatMessage({ id: 'WorkforceHeader.TitleTop' });
  let titleBottom = intl.messages['WorkforceHeader.TitleBottom'] ? intl.formatMessage({ id: 'WorkforceHeader.TitleBottom' }) : null;

  const categoryName = searchParams.facets ? getCurrentCategoryName(searchParams.facets) : '';
  if (categoryName.length) {
    metaTitle = intl.messages['Workforce.CategoryTitle'] ? intl.formatMessage({ id: 'Workforce.CategoryTitle' }, {
      sitename: process.env.REACT_APP_SITENAME,
      category: categoryName,
    }) : metaTitle;
    metaDescription = intl.messages['Workforce.CategoryMetaDescriptionTitle'] ? intl.formatMessage({ id: 'Workforce.CategoryMetaDescriptionTitle' }, {
      sitename: process.env.REACT_APP_SITENAME,
      category: categoryName,
    }) : metaDescription;
    titleTop = intl.messages['WorkforceHeader.CategoryTitleTop'] ? intl.formatMessage({ id: 'WorkforceHeader.CategoryTitleTop' }, { category: categoryName }) : titleTop;
    titleBottom = intl.messages['WorkforceHeader.CategoryTitleTopBottom'] ? intl.formatMessage({ id: 'WorkforceHeader.CategoryTitleTopBottom' }) : titleBottom;
  }

  return {
    metaTitle,
    metaDescription,
    titleTop,
    titleBottom,
  };
}

export default updateWorkforceSpecificMeta;
